import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SOINS } from "../data/content";
import { Reveal } from "../components/Reveal";
import EditorialMarquee from "../components/Marquee";

export default function Soins() {
  return (
    <div data-testid="soins-page">
      <section className="pt-32 lg:pt-40 pb-16 px-6 lg:px-12 max-w-7xl mx-auto">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-olive mb-6">Le soin</p>
          <h1 className="font-serif text-5xl sm:text-6xl font-light tracking-tight text-ink leading-tight max-w-3xl">Dix chemins vers l'équilibre</h1>
          <p className="mt-8 text-base sm:text-lg text-sage leading-relaxed max-w-2xl">
            Chi Nei Tsang, magnétisme, ventouses, réflexologie, massages du monde, ostéothérapie, breathwork… Choisissez le soin qui résonne avec votre besoin du moment — chaque page vous dit tout.
          </p>
        </Reveal>
      </section>

      <EditorialMarquee />

      <section className="py-20 lg:py-28 px-6 lg:px-12 max-w-7xl mx-auto">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14" data-testid="soins-grid">
          {SOINS.map((s, i) => (
            <Reveal key={s.slug} delay={(i % 3) * 0.1}>
              <Link to={`/soins/${s.slug}`} data-testid={`soin-card-${s.slug}`} className="group block">
                <div className="overflow-hidden rounded-3xl border border-olive-border">
                  <img
                    src={s.image}
                    alt={s.name}
                    className="w-full h-72 object-cover transition-transform duration-700 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <div className="mt-5 flex items-start justify-between gap-4">
                  <div>
                    <span className="font-serif text-lg text-olive/40">{String(i + 1).padStart(2, "0")} /</span>
                    <h2 className="mt-1 font-serif text-2xl text-ink group-hover:text-olive transition-colors duration-300">{s.name}</h2>
                    <p className="mt-1 text-xs tracking-wide text-stone2">{s.tag}</p>
                    <p className="mt-2 text-sm text-sage">{s.price} · {s.duration}</p>
                  </div>
                  <ArrowUpRight className="w-5 h-5 mt-1 shrink-0 text-olive-light transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" strokeWidth={1.5} />
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-olive-dark text-beige-100">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20 flex flex-wrap items-center justify-between gap-8">
          <Reveal>
            <h2 className="font-serif text-3xl sm:text-4xl font-light">Une hésitation sur le soin adapté ?</h2>
            <p className="mt-3 text-beige-300/85 max-w-md">Écrivez-moi : ensemble, nous trouverons ce qui vous correspond.</p>
          </Reveal>
          <Link to="/contact" data-testid="soins-cta-contact" className="inline-flex items-center rounded-full bg-beige-100 px-8 py-4 text-sm font-medium text-olive-dark transition-all duration-300 hover:-translate-y-0.5 hover:bg-beige-50">
            Demander conseil
          </Link>
        </div>
      </section>
    </div>
  );
}
